import React from 'react';
import PropTypes from 'prop-types';

const BankInformationItem = props => {
  const {name, type, account} = props
  return (
    <div>
      <p className="s-mb-0 s-color-light-text small">{name}</p>
      <p className="s-mb-0 s-color-lighter-text smaller">{type} - {account}</p>
    </div>
  );
};

BankInformationItem.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  account: PropTypes.string.isRequired,
};

export default BankInformationItem;
